import React, { useEffect, useState } from "react";
//Import Flatepicker
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  CardBody,
  CardHeader,
  Container,
  Card,
  Row,
  Col,
  Input,
  ModalHeader,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Form,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import Select from "react-select";

//redux
import { useSelector, useDispatch } from "react-redux";
// Import actions
import { getSellers as onGetSellers, addNewSeller, updateSeller, deleteSeller, suspendSeller } from "../../../slices/thunks";
import SellerChats from "./SellerChats";
import { createSelector } from "reselect";

const EcommerceSellers = () => {
  const dispatch = useDispatch();
  const [sellerList, setSellerList] = useState([]);
  const [modal, setModal] = useState(false);
  const [editingSeller, setEditingSeller] = useState(null);
  const [companyType, setcompanyType] = useState(null);
  
  // Form state
  const [formData, setFormData] = useState({
    // Personal Details
    first_name: '',
    last_name: '',
    email: '',
    contact_number: '',
    phone_number: '',
    date_of_birth: '',
    city: '',
    country: '',
    zip_code: '',
    description: '',
    password: '',
    // Business Details
    company_name: '',
    company_type: null,
    pan_card_number: '',
    website: '',
    fax: '',
    company_email: '',
    company_number: '',
    company_logo: null,
    // Bank Details
    bank_name: '',
    branch: '',
    account_holder_name: '',
    account_number: '',
    ifsc_code: ''
  });

  const selectsellerData = createSelector(
    (state) => state.Ecommerce,
    (ecommerce) => ecommerce.sellers || []
  );
  // Inside your component
  const sellers = useSelector(selectsellerData);

  useEffect(() => {
    dispatch(onGetSellers());
  }, [dispatch]);

  useEffect(() => {
    // Ensure sellers is always an array
    if (Array.isArray(sellers)) {
      setSellerList(sellers);
    } else if (sellers && !isEmpty(sellers)) {
      // If sellers is an object or has data property, handle it
      const sellersArray = sellers.data || (Array.isArray(sellers) ? sellers : []);
      setSellerList(Array.isArray(sellersArray) ? sellersArray : []);
    } else {
      setSellerList([]);
    }
  }, [sellers]);

  const toggle = (seller = null) => {
    if (modal) {
      setModal(false);
      resetForm();
    } else {
      setModal(true);
      if (seller) {
        setEditingSeller(seller);
        // Populate form with seller data
        setFormData({
          first_name: seller.first_name || '',
          last_name: seller.last_name || '',
          email: seller.email || '',
          contact_number: seller.contact_number || '',
          phone_number: seller.phone_number || '',
          date_of_birth: seller.date_of_birth || '',
          city: seller.city || '',
          country: seller.country || '',
          zip_code: seller.zip_code || '',
          description: seller.description || '',
          password: '',
          company_name: seller.company_name || '',
          company_type: seller.company_type ? { label: seller.company_type, value: seller.company_type } : null,
          pan_card_number: seller.pan_card_number || '',
          website: seller.website || '',
          fax: seller.fax || '',
          company_email: seller.company_email || '',
          company_number: seller.company_number || '',
          company_logo: null,
          bank_name: seller.bank_name || '',
          branch: seller.branch || '',
          account_holder_name: seller.account_holder_name || '',
          account_number: seller.account_number || '',
          ifsc_code: seller.ifsc_code || ''
        });
        setcompanyType(seller.company_type ? { label: seller.company_type, value: seller.company_type } : null);
      } else {
        setEditingSeller(null);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      contact_number: '',
      phone_number: '',
      date_of_birth: '',
      city: '',
      country: '',
      zip_code: '',
      description: '',
      password: '',
      company_name: '',
      company_type: null,
      pan_card_number: '',
      website: '',
      fax: '',
      company_email: '',
      company_number: '',
      company_logo: null,
      bank_name: '',
      branch: '',
      account_holder_name: '',
      account_number: '',
      ifsc_code: ''
    });
    setcompanyType(null);
    setEditingSeller(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({
        ...prev,
        company_logo: e.target.files[0]
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const submitData = new FormData();
      
      // Add all form fields to FormData
      Object.keys(formData).forEach(key => {
        if (key === 'company_logo' && formData[key]) {
          submitData.append('company_logo', formData[key]);
        } else if (key === 'company_type' && formData[key]) {
          submitData.append('company_type', typeof formData[key] === 'object' ? formData[key].value : formData[key]);
        } else if (formData[key] !== null && formData[key] !== '') {
          submitData.append(key, formData[key]);
        }
      });

      if (editingSeller) {
        // Update seller
        await dispatch(updateSeller({
          _id: editingSeller.id || editingSeller._id,
          formData: submitData
        })).unwrap();
        toggleEdit();
      } else {
        // Add new seller
        if (!formData.password) {
          alert('Password is required for new sellers');
          return;
        }
        await dispatch(addNewSeller({
          formData: submitData
        })).unwrap();
        toggle();
      }
    } catch (error) {
      console.error('Error submitting seller:', error);
    }
  };

  const handleSuspend = async (seller, status) => {
    if (window.confirm(`Are you sure you want to ${status === 'suspended' ? 'suspend' : 'activate'} this seller?`)) {
      try {
        await dispatch(suspendSeller({
          sellerId: seller.id || seller._id,
          status: status
        })).unwrap();
      } catch (error) {
        console.error('Error suspending seller:', error);
      }
    }
  };

  const handleDelete = async (sellerId) => {
    if (window.confirm('Are you sure you want to delete this seller? This action cannot be undone.')) {
      try {
        await dispatch(deleteSeller(sellerId)).unwrap();
      } catch (error) {
        console.error('Error deleting seller:', error);
      }
    }
  };

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const companytypes = [
    {
      options: [
        { label: "Select type", value: "Select type" },
        { label: "All", value: "All" },
        { label: "Merchandising", value: "Merchandising" },
        { label: "Manufacturing", value: "Manufacturing" },
        { label: "Partnership", value: "Partnership" },
        { label: "Corporation", value: "Corporation" },
      ],
    },
  ];

  function handlecompanyType(companyType) {
    setcompanyType(companyType);
  }

  const category = (e) => {
    if (!Array.isArray(sellers)) return;
    
    if (e === "All") {
      var filter = sellers.filter((item) => item.category !== e);
    } else {
      filter = sellers.filter((item) => item.category === e || item.company_type === e);
    }
    setSellerList(Array.isArray(filter) ? filter : []);
  };

  document.title = "Sellers - Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Sellers" pageTitle="Dashboard" />
          <Card>
            <CardHeader className="border-0 rounded">
              <Row className="g-2">
                <Col xl={3}>
                  <div className="search-box">
                    <Input
                      type="text"
                      className="form-control search"
                      placeholder="Search for sellers & owner name or something..."
                    />{" "}
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <Col xxl={3} className="ms-auto">
                  <div>
                    <select className="form-control"
                      onChange={(e) => category(e.target.value)}
                    >
                      <option value="All">Select Categories</option>
                      <option value="All">All</option>
                      <option value="Retailer">Retailer</option>
                      <option value="Health & Medicine">
                        Health & Medicine
                      </option>
                      <option value="Manufacturer">Manufacturer</option>
                      <option value="Food Service">Food Service</option>
                      <option value="Computers & Electronics">
                        Computers & Electronics
                      </option>
                    </select>
                  </div>
                </Col>
                <div className="col-lg-auto">
                  <div className="hstack gap-2">
                    <button type="button" className="btn btn-danger">
                      <i className="ri-equalizer-fill me-1 align-bottom"></i>{" "}
                      Filters
                    </button>
                    <Link
                      to="/add-seller"
                      className="btn btn-success"
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Add
                      Seller
                    </Link>
                  </div>
                </div>
              </Row>
            </CardHeader>
          </Card>

          <Row className="mt-4">
            {Array.isArray(sellerList) && sellerList.length > 0 ? sellerList.map((seller, key) => (
              <React.Fragment key={key}>
                <Col xl={3} lg={6}>
                  <Card className="ribbon-box right overflow-hidden">
                    <CardBody className="text-center p-4">
                      {seller.isTrending && (
                        <div className="ribbon ribbon-info ribbon-shape trending-ribbon">
                          <i className="ri-flashlight-fill text-white align-bottom"></i>{" "}
                          <span className="trending-ribbon-text">Trending</span>
                        </div>
                      )}
                      <img src={seller.img || seller.company_logo || '/assets/images/users/multi-user.jpg'} alt="" height="45" />
                      <h5 className="mb-1 mt-4">
                        <Link
                          to={`/seller-details/${seller.id || seller._id}`}
                          className="link-primary"
                        >
                          {seller.label || seller.company_name || `${seller.first_name || ''} ${seller.last_name || ''}`.trim()}
                        </Link>
                      </h5>
                      <p className="text-muted mb-4">{seller.name || `${seller.first_name || ''} ${seller.last_name || ''}`.trim()}</p>
                      <Row className="justify-content-center">
                        <Col lg={8}>
                          <SellerChats
                            color={seller.color || '#5156be'}
                            data={seller.chartdata || [10, 20, 30, 40, 50, 60, 70]}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col lg={6} className="border-end-dashed border-end">
                          <h5>{seller.stock !== undefined ? seller.stock : (seller.total_stock || 0)}</h5>
                          <span className="text-muted">Item Stock</span>
                        </Col>
                        <Col lg={6}>
                          <h5>{seller.balance !== undefined ? seller.balance : (seller.wallet_balance || 0)}</h5>
                          <span className="text-muted">Wallet Balance</span>
                        </Col>
                      </Row>
                      <div className="mt-4">
                        <div className="d-flex gap-2">
                          <Link
                            to={`/seller-details/${seller.id || seller._id}`}
                            className="btn btn-light flex-fill"
                          >
                            View Details
                          </Link>
                          <button
                            className="btn btn-primary"
                            onClick={() => toggle(seller)}
                            title="Edit Seller"
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                          <button
                            className={`btn ${(seller.status === 'suspended') ? 'btn-success' : 'btn-warning'}`}
                            onClick={() => handleSuspend(seller, seller.status === 'suspended' ? 'active' : 'suspended')}
                            title={seller.status === 'suspended' ? 'Activate Seller' : 'Suspend Seller'}
                          >
                            <i className={seller.status === 'suspended' ? 'ri-check-line' : 'ri-pause-line'}></i>
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleDelete(seller.id || seller._id)}
                            title="Delete Seller"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </React.Fragment>
            )) : (
              <Col xl={12}>
                <div className="text-center py-5">
                  <p className="text-muted">No sellers found. Click "Add Seller" to create one.</p>
                </div>
              </Col>
            )}
          </Row>

          <Row className="g-0 text-center text-sm-start align-items-center mb-3">
            <Col sm={6}>
              <div>
                <p className="mb-sm-0">Showing 1 to 8 of 12 entries</p>
              </div>
            </Col>
            <Col sm={6}>
              <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                <li className="page-item disabled">
                  {" "}
                  <Link to="#" className="page-link">
                    <i className="mdi mdi-chevron-left"></i>
                  </Link>{" "}
                </li>
                <li className="page-item active">
                  {" "}
                  <Link to="#" className="page-link">
                    1
                  </Link>{" "}
                </li>
                <li className="page-item ">
                  {" "}
                  <Link to="#" className="page-link">
                    2
                  </Link>{" "}
                </li>
                <li className="page-item">
                  {" "}
                  <Link to="#" className="page-link">
                    3
                  </Link>{" "}
                </li>
                <li className="page-item">
                  {" "}
                  <Link to="#" className="page-link">
                    4
                  </Link>{" "}
                </li>
                <li className="page-item">
                  {" "}
                  <Link to="#" className="page-link">
                    5
                  </Link>{" "}
                </li>
                <li className="page-item">
                  {" "}
                  <Link to="#" className="page-link">
                    <i className="mdi mdi-chevron-right"></i>
                  </Link>{" "}
                </li>
              </ul>
            </Col>
          </Row>

          <Modal
            className="zoomIn"
            id="addSeller"
            size="lg"
            isOpen={modal}
            toggle={toggle}
            centered
          >
            <ModalHeader toggle={toggle}>{editingSeller ? 'Edit Seller' : 'Add Seller'}</ModalHeader>
            <div className="modal-content border-0 mt-3">
              <Nav className="nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Personal Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Business Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    Bank Details
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <ModalBody>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="firstnameInput" className="form-label">
                            First Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="firstnameInput"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            placeholder="Enter your firstname"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="lastnameInput" className="form-label">
                            Last Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="lastnameInput"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            placeholder="Enter your lastname"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            for="contactnumberInput"
                            className="form-label"
                          >
                            Contact Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="contactnumberInput"
                            name="contact_number"
                            value={formData.contact_number}
                            onChange={handleInputChange}
                            placeholder="Enter your number"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="phonenumberInput" className="form-label">
                            Phone Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="phonenumberInput"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleInputChange}
                            placeholder="Enter your number"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="emailidInput" className="form-label">
                            Email
                          </Label>
                          <Input
                            type="email"
                            className="form-control"
                            id="emailidInput"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter your email"
                            required
                          />
                        </div>
                      </Col>
                      {!editingSeller && (
                        <Col lg={4}>
                          <div className="mb-3">
                            <Label for="passwordInput" className="form-label">
                              Password
                            </Label>
                            <Input
                              type="password"
                              className="form-control"
                              id="passwordInput"
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              placeholder="Enter password"
                              required={!editingSeller}
                            />
                          </div>
                        </Col>
                      )}
                      {/* <Col lg={6}>
                        <div className="mb-3">
                          <Label for="birthdayidInput" className="form-label">
                            Date of Birth
                          </Label>
                          <Flatpickr
                            className="form-control"
                            name="date_of_birth"
                            value={formData.date_of_birth}
                            onChange={(date) => {
                              setFormData(prev => ({
                                ...prev,
                                date_of_birth: date[0] ? date[0].toISOString().split('T')[0] : ''
                              }));
                            }}
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select Date"
                          />
                        </div>
                      </Col> */}
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label for="cityidInput" className="form-label">
                            City
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="cityidInput"
                            name="city"
                            value={formData.city}
                            onChange={handleInputChange}
                            placeholder="Enter your city"
                          />
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label for="countryidInput" className="form-label">
                            Country
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="countryidInput"
                            name="country"
                            value={formData.country}
                            onChange={handleInputChange}
                            placeholder="Enter your country"
                          />
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label for="zipcodeidInput" className="form-label">
                            Zip Code
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="zipcodeidInput"
                            name="zip_code"
                            value={formData.zip_code}
                            onChange={handleInputChange}
                            placeholder="Enter your zipcode"
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="mb-3">
                          <Label
                            for="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Description
                          </Label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            rows="3"
                            placeholder="Enter description"
                          ></textarea>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-link link-success text-decoration-none fw-medium"
                            onClick={toggle}
                          >
                            <i className="ri-close-line me-1 align-middle"></i>{" "}
                            Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab("2");
                            }}
                          >
                            Next <i className="ri-arrow-right-line align-bottom me-1"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tabId="2">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(e);
                  }}>
                    <Row>
                      <Col lg={12}>
                        <div className="mb-3">
                          <Label for="companynameInput" className="form-label">
                            Company Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="companynameInput"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleInputChange}
                            placeholder="Enter your company name"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            for="choices-single-default"
                            className="form-label"
                          >
                            Company Type
                          </Label>
                          <Select
                            name="company_type"
                            id="choices-single-default"
                            value={companyType}
                            onChange={(selected) => {
                              setcompanyType(selected);
                              setFormData(prev => ({
                                ...prev,
                                company_type: selected
                              }));
                            }}
                            options={companytypes[0].options.filter(opt => opt.value !== "Select type" && opt.value !== "All")}
                          />
                        </div>
                      </Col>
                      {/* <Col lg={6}>
                        <div className="mb-3">
                          <Label for="pancardInput" className="form-label">
                            Pan Card Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="pancardInput"
                            name="pan_card_number"
                            value={formData.pan_card_number}
                            onChange={handleInputChange}
                            placeholder="Enter your pan-card number"
                          />
                        </div>
                      </Col> */}
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="websiteInput" className="form-label">
                            Website
                          </Label>
                          <Input
                            type="url"
                            className="form-control"
                            id="websiteInput"
                            name="website"
                            value={formData.website}
                            onChange={handleInputChange}
                            placeholder="Enter your URL"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="faxInput" className="form-label">
                            Fax
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="faxInput"
                            name="fax"
                            value={formData.fax}
                            onChange={handleInputChange}
                            placeholder="Enter your fax"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="companyemailInput" className="form-label">
                            Email
                          </Label>
                          <Input
                            type="email"
                            className="form-control"
                            id="companyemailInput"
                            name="company_email"
                            value={formData.company_email}
                            onChange={handleInputChange}
                            placeholder="Enter your email"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="worknumberInput" className="form-label">
                            Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="worknumberInput"
                            name="company_number"
                            value={formData.company_number}
                            onChange={handleInputChange}
                            placeholder="Enter your number"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="companylogoInput" className="form-label">
                            Company Logo
                          </Label>
                          <Input
                            type="file"
                            className="form-control"
                            id="companylogoInput"
                            name="company_logo"
                            onChange={handleFileChange}
                            accept="image/*"
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-link link-success text-decoration-none fw-medium"
                            onClick={toggle}
                          >
                            <i className="ri-close-line me-1 align-middle"></i>{" "}
                            Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              toggleTab("1");
                            }}
                          >
                            <i className="ri-arrow-left-line align-bottom me-1"></i> Previous
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab("3");
                            }}
                          >
                            Next <i className="ri-arrow-right-line align-bottom me-1"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </TabPane>
                <TabPane tabId="3">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="banknameInput" className="form-label">
                            Bank Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="banknameInput"
                            name="bank_name"
                            value={formData.bank_name}
                            onChange={handleInputChange}
                            placeholder="Enter your bank name"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="branchInput" className="form-label">
                            Branch
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="branchInput"
                            name="branch"
                            value={formData.branch}
                            onChange={handleInputChange}
                            placeholder="Branch"
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="mb-3">
                          <Label for="accountnameInput" className="form-label">
                            Account Holder Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="accountnameInput"
                            name="account_holder_name"
                            value={formData.account_holder_name}
                            onChange={handleInputChange}
                            placeholder="Enter account holder name"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            for="accountnumberInput"
                            className="form-label"
                          >
                            Account Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="accountnumberInput"
                            name="account_number"
                            value={formData.account_number}
                            onChange={handleInputChange}
                            placeholder="Enter account number"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label for="ifscInput" className="form-label">
                            IFSC
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="ifscInput"
                            name="ifsc_code"
                            value={formData.ifsc_code}
                            onChange={handleInputChange}
                            placeholder="IFSC"
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-link link-success text-decoration-none fw-medium"
                            onClick={toggle}
                          >
                            <i className="ri-close-line me-1 align-middle"></i>{" "}
                            Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              toggleTab("2");
                            }}
                          >
                            <i className="ri-arrow-left-line align-bottom me-1"></i> Previous
                          </button>
                          <button type="submit" className="btn btn-primary">
                            <i className="ri-save-3-line align-bottom me-1"></i>{" "}
                            {editingSeller ? 'Update All' : 'Save All'}
                          </button>
                        </div>
                      </Col>
                    </div>
                  </form>
                </TabPane>
              </TabContent>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EcommerceSellers;